export async function waitUntil(
	condition: () => Promise<boolean>,
	timeoutMs: number = 5000,
): Promise<boolean> {
	const start = Date.now();
	return new Promise((resolve, reject) => {
		(async function wait() {
			if (await condition()) return resolve(true);
			if (Date.now() - start > timeoutMs) return resolve(false);
			setTimeout(wait, 500);
		})();
	});
}
